import { useStorage } from "@vueuse/core";
import { resolveCurrency } from "@orie/sdk";
// import config from "#sales";

export const useCurrency = () => {
  const config = useAppConfig();
  const currencyValue = useStorage("currency", config.commerce.defaultCurrency);
  // const currencyValue = useStorage("currency", config.defaultCurrency);
  const currency = computed(() => resolveCurrency(currencyValue.value));

  const set = (code: string) => (currencyValue.value = code);

  return {
    currencyValue,
    currency,
    set,
  };
};
